import Button, { type ButtonProps } from 'components/button'
import { useColorScheme } from '../colorScheme'
import { DarkModeRoundedIcon, LightModeIcon } from 'components/icons'
import * as React from 'react'

interface ColorSchemeToggleProps extends ButtonProps {
    onClick?: (event: any) => void
}

export default function ColorSchemeToggle({ onClick, ...props }: ColorSchemeToggleProps) {
    const { resolvedScheme, setScheme } = useColorScheme()
    const [mounted, setMounted] = React.useState(false)

    React.useEffect(() => {
        setMounted(true)
    }, [])

    if (!mounted) {
        return (
            <Button
                variant="outlined"
                disabled
                size="$3"
                {...props}
            />
        )
    }

    return (
        <Button
            id="toggle-mode"
            variant="outlined"
            size="$3"
            icon={resolvedScheme === 'dark' ? <LightModeIcon /> : <DarkModeRoundedIcon />}
            onPress={(event) => {
                if (resolvedScheme === 'light') {
                    setScheme('dark')
                } else {
                    setScheme('light')
                }
                onClick?.(event)
            }}
            {...props}
        />
    )
}
